import { faPercentage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TextField } from "monday-ui-react-core";
import { useCallback, useState } from "react";
import Classes from "./NumberInput.module.scss";

type NumberInputProps = {
  title: string;
  placeholder: string;
  name: string;
  onlyPositive?: boolean;
  isCurrency?: boolean; 
  isRate?: boolean;
  onBlur?: (value: number) => void;
  onChange?: (value: number) => void;
};

const NumberInput = ({
  title,
  placeholder,
  name,
  onlyPositive = true,
  isCurrency = false,
  isRate = false,
  onBlur,
  onChange,
}: NumberInputProps) => {
  const [validation, setValidation] = useState({});
  const [value, setValue] = useState<string>("");

  const _onChange = useCallback(
    (inputValue: string) => {
      // Remove all commas so we can parse the number
      const numericValue = inputValue.replace(/,/g, "");
      const floatValue = parseFloat(numericValue);

      // Validation
      if (onlyPositive && floatValue < 0) {
        setValidation({ status: "error", text: "לא ניתן להזין מספר שלילי" });
        setValue("0");
        return;
      }

      setValidation({});

      // Format with commas for display
      const formattedValue = numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      setValue(formattedValue);

      // Call onChange with the numeric value (0 if empty)
      if (onChange) {
        if (numericValue === "" || isNaN(floatValue)) {
          onChange(0);
        } else {
          onChange(floatValue);
        }
      }
    },
    [setValidation, setValue, onlyPositive, onChange]
  );

  const _onBlur = useCallback(() => {
    if (onBlur) {
      if (value === "" || value.replace(/,/g, "") === "") {
        onBlur(0);
      } else {
        const floatValue = parseFloat(value.replace(/,/g, ""));
        onBlur(floatValue);
      }
    }
  }, [value, onBlur]);

  const rateIcon = () => {
    return <FontAwesomeIcon icon={faPercentage} />;
  };

  const currencyIcon = () => {
    return <span style={{ fontWeight: "bold", fontSize: "1rem" }}>₪</span>;
  };

  return (
    <TextField
      type={TextField.types.TEXT}
      title={title}
      inputAriaLabel={title}
      name={name}
      value={value}
      iconName={isRate ? rateIcon : isCurrency ? currencyIcon : ""} 
      placeholder={placeholder}
      validation={validation}
      onChange={_onChange}
      onBlur={_onBlur}
      wrapperClassName={Classes.numberInputWrapper}
    />
  );
};

export default NumberInput;
